/* esm.sh - applesauce-relay@5.2.0/dist/operators/complete-on-eose */
import{takeWhile as t}from"rxjs";function n(e){return t(o=>o!=="EOSE",e)}export{n as completeOnEose};
//# sourceMappingURL=complete-on-eose.mjs.map